import { withPrefix } from 'gatsby';

import { T } from '@fire/i18n/i18n-constants';

export const PREFIX = T?.AvailabilityBox ?? '';
export const HOMEPAGE_PREFIX = T?.HomePage;
export const TILE_PREFIX = T.Tile;
export const INFO_ICON = withPrefix('/icons/info-blue.svg');
